var map = {
	"./apple.svg": 50,
	"./bananas.svg": 51,
	"./basket.svg": 27,
	"./beer.svg": 52,
	"./beetroot.svg": 53,
	"./belpepper.svg": 54,
	"./bread.svg": 55,
	"./brinjal.svg": 56,
	"./brocolli.svg": 57,
	"./cabbage.svg": 58,
	"./card.svg": 28,
	"./carrot.svg": 59,
	"./cheese.svg": 60,
	"./cherry.svg": 61,
	"./chilli.svg": 62,
	"./chocolates.svg": 63,
	"./coke.svg": 64,
	"./cookies.svg": 65,
	"./eggs.svg": 66,
	"./garlic.svg": 67,
	"./girl-ills.svg": 68,
	"./juice.svg": 69,
	"./landing.svg": 29,
	"./lettuce.svg": 70,
	"./mango.svg": 71,
	"./milk.svg": 72,
	"./onion.svg": 73,
	"./orange.svg": 74,
	"./pear.svg": 75,
	"./pineapple.svg": 76,
	"./popcorn.svg": 77,
	"./potato.svg": 78,
	"./radish.svg": 79,
	"./strawberry.svg": 80,
	"./tomato.svg": 81,
	"./watermelon.svg": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;